module.exports = __webpack_public_path__ + "static/media/291800.c183a6a8.png";